import React, { useState } from 'react';
import { Pause, Play } from 'lucide-react';
import { CLIENT_LOGOS } from '../content';

// View boxes remove uneven empty borders without modifying or stretching brand artwork.
const FRAMES = {
  '/logos/emaar.webp': [169,120,'26 45 117 30'],
  '/logos/nakheel.webp': [120,120,'13 36 94 48'],
  '/logos/aldar.webp': [120,120,'-4 -4 128 128'],
  '/logos/majid-al-futtaim.webp': [249,300,'-4 -4 257 308'],
  '/logos/address.webp': [230,120,'61 21 109 78'],
  '/logos/shurooq.webp': [533,300,'126 10 281 270'],
  '/logos/twofour54.webp': [274,120,'18 18 238 84'],
  '/logos/bottega.webp': [213,120,'0 23 213 74'],
  '/logos/intermass.webp': [300,300,'40 26 220 229'],
  '/logos/ginco.webp': [388,300,'14 19 357 275'],
};

export default function ClientLogoMarquee() {
  const [paused, setPaused] = useState(false);
  return (
    <div data-testid="client-logos-marquee" className="client-logo-carousel relative overflow-hidden border-y border-[#6E1F2C]/15 bg-[#FAF5EC]">
      <div className="client-logo-track" style={{animationPlayState: paused ? 'paused' : 'running'}}>
        {[0,1].map(copy => (
          <div key={copy} className="client-logo-group" aria-hidden={copy === 1 ? true : undefined}>
            {CLIENT_LOGOS.map(logo => {
              const [width,height,viewBox] = FRAMES[logo.src];
              return (
                <div key={logo.src} className="client-logo-slot">
                  <svg viewBox={viewBox} role="img" aria-label={logo.name} className="client-logo-art" xmlns="http://www.w3.org/2000/svg">
                    <image href={logo.src} width={width} height={height} />
                  </svg>
                </div>
              );
            })}
          </div>
        ))}
      </div>
      <div className="client-logo-fade client-logo-fade-left" aria-hidden="true" />
      <div className="client-logo-fade client-logo-fade-right" aria-hidden="true" />
      <button type="button" data-testid="client-logos-toggle" aria-label={paused ? 'Play client logos' : 'Pause client logos'} aria-pressed={paused}
        className="client-logo-toggle" onClick={() => setPaused(value => !value)}>
        {paused ? <Play size={14} /> : <Pause size={14} />}
      </button>
    </div>
  );
}
